import React from 'react';

import { L10n } from '~src/ts/L10n/L10n';

import { Messages } from '../../../codegen/Localize';
import { ConnectionTypeEntity } from '../../../datasource/components/tooltips/DatasourceEntity';
import { IDataSourceInfo} from '../../../datasource/models/IDataSourceInfo';
import { DatasourceTooltip } from './Elements/Tooltip';
import { StatusTooltipProps} from './TooltipHelper';

let embeddedDSMessage: string;
let embeddedConnectionMessage: string;

export function NameToolTip(props: StatusTooltipProps): JSX.Element {
  const datasource = props.content as IDataSourceInfo;
  toolTipContent(props.content);
  return (
    <DatasourceTooltip>
      <ConnectionTypeEntity name = {datasource.name} fileType={embeddedDSMessage} connectionDetails={embeddedConnectionMessage}/>
    </DatasourceTooltip>
  );
}

function toolTipContent(datasource: IDataSourceInfo) {
  if(datasource.hasExtracts){
    if(datasource.hasEncryptableExtracts){
      let encryptionState= datasource.extractEncryptionState;
      embeddedDSMessage= Messages.encryptedExtractEmbedded({ENCRYPTION_STATE: encryptionState.charAt(0).toUpperCase()+encryptionState.substring(1),UNICODE:String.fromCharCode(8212)});}
    else{
      embeddedDSMessage = Messages.datasourceEmbedded({LIVE_OR_EXTRACT:Messages.extract(),UNICODE:String.fromCharCode(8212)});}
    embeddedConnectionMessage = Messages.lastRefreshed()+' '+L10n.localizedDateTime(datasource.lastRefreshedAt);
  }
  else{
  embeddedDSMessage= Messages.datasourceEmbedded({LIVE_OR_EXTRACT:Messages.live(),UNICODE:String.fromCharCode(8212)});
  embeddedConnectionMessage = undefined;}
}




